import { SVGProps } from 'react';

const GcrIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    {...props}
  >
    <path d="M14.874 20.584a.75.75 0 0 1-.624 1.166h-12a.75.75 0 0 1-.63-1.156l3.374-5.25a.75.75 0 0 1 1.262 0l.915 1.423 1.955-2.933a.75.75 0 0 1 1.248 0l4.5 6.75ZM20.25 8.25v12a1.5 1.5 0 0 1-1.5 1.5H18a.75.75 0 1 1 0-1.5h.75V9h-4.5a.75.75 0 0 1-.75-.75v-4.5H5.25V12a.75.75 0 1 1-1.5 0V3.75a1.5 1.5 0 0 1 1.5-1.5h9a.75.75 0 0 1 .53.22l5.25 5.25a.748.748 0 0 1 .22.53ZM15 7.5h2.69L15 4.81V7.5Z" />
  </svg>
);

export default GcrIcon;
